export default __webpack_public_path__ + "static/media/address.8335363a.svg";